// extracted by mini-css-extract-plugin
export default {"registered-view":"index_registered-view__j0oZq"};